const DATABASE_NAME = "turbo-offline-database"
const DATABASE_VERSION = 3

let databasePromise = null

export function openDatabase() {
  if (!databasePromise) {
    databasePromise = new Promise((resolve, reject) => {
      const request = indexedDB.open(DATABASE_NAME, DATABASE_VERSION)

      request.onupgradeneeded = (event) => {
        const database = request.result
        const oldVersion = event.oldVersion

        if (oldVersion < 1) {
          const cacheRegistryStore = database.createObjectStore("cache-registry", { keyPath: "key" })
          cacheRegistryStore.createIndex("cacheNameAndTimestamp", ["cacheName", "timestamp"])
        }

        if (oldVersion < 2) {
          const recordsStore = database.createObjectStore("records", { keyPath: "key" })
        }

        if (oldVersion < 3 && database.objectStoreNames.contains("templates")) {
          database.deleteObjectStore("templates")
        }
      }

      request.onsuccess = () => resolve(request.result)
      request.onerror = () => reject(request.error)
    })
  }

  return databasePromise
}

export function deleteDatabase() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.deleteDatabase(DATABASE_NAME)
    request.onsuccess = () => resolve()
    request.onerror = () => reject(request.error)
  }).then(() => {
    databasePromise = null
  })
}

export async function performTransaction(storeName, mode, operation) {
  const database = await openDatabase()
  const transaction = database.transaction(storeName, mode)
  return operation(transaction.objectStore(storeName))
}

export function requestToPromise(request) {
  return new Promise((resolve, reject) => {
    request.oncomplete = request.onsuccess = () => resolve(request.result)
    request.onabort = request.onerror = () => reject(request.error)
  })
}

export function cursorRequestToPromise(request, limit = Infinity) {
  return new Promise((resolve, reject) => {
    const results = []

    request.onsuccess = (event) => {
      const cursor = event.target.result
      if (cursor && results.length < limit) {
        results.push(cursor.value)
        cursor.continue()
      } else {
        resolve(results)
      }
    }

    request.onerror = () => reject(request.error)
  })
}
